import { createInterceptorCondition, IncludeBearerTokenCondition } from 'keycloak-angular';

/**
 * Escapa caracteres especiais de RegExp (., ?, *, +, …) para que a URL seja
 * interpretada como texto literal.
 */
function escapeForRegExp(url: string): string {
    return url.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Cria um array de condições para o IncludeBearerTokenInterceptor
 * a partir da lista de URLs do environment.
 */
export function buildBearerTokenConditions(
    ...urls: string[]
) {
    return urls
        .filter(Boolean)            // descarta undefined / null
        .map((url) =>
            createInterceptorCondition<IncludeBearerTokenCondition>({
                urlPattern: new RegExp(`^${escapeForRegExp(url)}/.*`, 'i'),
                bearerPrefix: 'Bearer',
            }),
        );
}
